import { render, staticRenderFns } from "./color-boxes.vue?vue&type=template&id=e5be8d9e&"
import script from "./color-boxes.vue?vue&type=script&lang=js&"
export * from "./color-boxes.vue?vue&type=script&lang=js&"
import style0 from "./color-boxes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports